import React from 'react'
import { Link } from 'react-router-dom'

export function CancelPage() {
  React.useEffect(() => {
    const stored = localStorage.getItem('nudge-theme')
    if (stored === 'light' || stored === 'dark') {
      document.documentElement.setAttribute('data-theme', stored)
    }
  }, [])

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      padding: 24,
    }}>
      <div style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 16,
        padding: '40px 36px',
        maxWidth: 440,
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 36, marginBottom: 16 }}>👋</div>
        <div style={{ fontSize: 17, fontWeight: 600, color: 'var(--text)', marginBottom: 8 }}>
          No problem — nothing was charged
        </div>
        <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 28 }}>
          You&apos;re still on your current plan. Head back to billing settings whenever you&apos;re ready to upgrade.
        </div>
        <Link
          to="/dashboard"
          style={{
            display: 'inline-block',
            padding: '10px 28px',
            borderRadius: 8,
            background: 'var(--accent)',
            color: '#fff',
            fontSize: 14,
            fontWeight: 600,
            textDecoration: 'none',
          }}
        >
          Back to dashboard
        </Link>
      </div>
    </div>
  )
}
